export const DEFAULT_LAYOUT_STYLE = 'default';
export const SIDE_NAV_COLLAPSED='collapsed';